import React, { Component } from "react";
import OccasionalMarking from "../../../components/OccasionalMarking/OccasionalMarking";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AOccasionalMarkingForm
Description : Componente que invoca al componente OccasionalMarking.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class OccasionalMarkingForm extends Component {
    render() {
        return (
            <OccasionalMarking />
        )
    }
}

export default OccasionalMarkingForm;